
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldDescription from "./FieldDescription";
import FieldDuration from "./FieldDuration";
import FieldImage from "./FieldImage";
import FieldTitle from "./FieldTitle";
import FieldVideo from "./FieldVideo";


export default function Form({ episode }) {
	const navigate = useNavigate();
	const params = useParams();
	const episodeId = params.episodeId;
	const [title, setTitle] = useState(episode.title);
	const [description, setDescription] = useState(episode.description);
	const [duration, setDuration] = useState(episode.duration);
	const [image, setImage] = useState(episode.image || null);
	const [video, setVideo] = useState(episode.video || null);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	}

	const handleDurationChange = (e) => {
		setDuration(e.target.value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleVideoChange = (e) => {
		setVideo(e.target.files[0]);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.episodeEdit({
			token: LoginHelper.getToken(),
			episode_id: episodeId,
			title: title,
			description: description,
			duration: duration,
			image_file: image,
			video_file: video,
		}).then((result) => {
			setIsLoading(false);
			let workshopId = result.workshop;
			navigate('/workshop_detail/' + workshopId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="ویرایش جلسه"
			subtitle="تغییرات این جلسه را ذخیره کنید."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="ذخیره جلسه"
		>
			<EditorFieldSection title="اطلاعات جلسه">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldDescription description={description} onChange={handleDescriptionChange} />
				<FieldDuration duration={duration} onChange={handleDurationChange} />
			</EditorFieldSection>
			<EditorFieldSection title="فایل‌ها">
				<FieldImage image={image} onChange={handleImageChange} />
				<FieldVideo video={video} onChange={handleVideoChange} />
			</EditorFieldSection>
		</EditorFormShell>
	);
}
